import React, { Fragment } from "react";

import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { useCubicoAnalytics } from "./cubico_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./cubico_partner_config";
import { lazyWithRetry } from "../../core/lazy_with_retry";

const Theme = lazyWithRetry(() => import("./cubico_theme"));

const faqs = [
  {
    question: "Do I need to book in advance to use my Cubico Multi-Pass?",
    answer:
      "Yes. You will need to book ahead of time to secure space. " +
      "When possible, we will accommodate walk-ins according to availability.",
  },
  {
    question: "Can I cancel my Multi-Pass order?",
    answer: "Unfortunately, the Cubico Multi-Pass is non-refundable.",
  },
];

export function OfferingCubicoMultiPass() {
  useCubicoAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          description:
            "Enjoy access to all of Cubico's communal spaces for several days a week with the multi pass.",
          faqs,
          testimonials: testimonials,
          generalInfo: generalInfo,
        }}
      />
    </Fragment>
  );
}
